import Util from "@/Master/Util";
import {GameMsgKey} from "@/app/(game)/GameMsgKey";

export default class GameMsgUtil {
    static tag2: string = '[GameMsg-子]';
    static tag1: string = '[GameMsg-父]';
    static iframeOrigin: string = '*';

    //向父级发送消息
    static sendMsgParent(data:any){
        if (!Util.isWindow){
            return;
        }
        if (!window.parent){
            console.error('window.parent == null')
            return;
        }
        // 子页面发送请求给父页面
        window.parent.postMessage(data, this.iframeOrigin);

        if (Util.isLog) {
            console.log(`${this.tag2} 向父级发送消息`, data, this.iframeOrigin);
        }
    }

    //向下级发送消息
    static sendMsgLower(data:any){
        if (!Util.isWindow){
            return;
        }
        if (!window.iframeWindow){
            if (Util.isLog){
                console.warn('iframeWindow == null', data);
            }
            return;
        }
        window.iframeWindow.postMessage(data, this.iframeOrigin);
        if (Util.isLog) {
            console.log(`${this.tag1} 向下级发送消息`, data, this.iframeOrigin);
        }
    }

    //todo 充值完成和提现完成
    static sendMsgLowerSyncData(){
        GameMsgUtil.sendMsgLower({
            type: GameMsgKey.game_sync_data,
        });
    }

    static sendMsgLowerBackToGame(){
        GameMsgUtil.sendMsgLower({
            type: GameMsgKey.game_back_to_game,
        });
    }

}